import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges, ViewChild, Output } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, debounceTime, switchMap, map } from 'rxjs/operators';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CRMService } from '../../services/crm.service';
import { APIResponse, CustomerLookup } from '../../models/models';

@Component({
    selector: 'customer-dropdown',
    templateUrl: './customer-dropdown.component.html',
    standalone: false
})
export class CustomerDropdown implements OnInit, OnChanges {
    @Input() parentForm: UntypedFormGroup = new UntypedFormGroup({});
    @Input() ctrlName: string = "customerLookupCtrl";
    @Input() customerID: number = 0;
    @Input() placeholder: string = "Select";
    @Input() isChooseFirstCustomer: boolean = false;
    @Input() lookupType: string = "all";
    @Input() isDisabled: boolean = false;
    @Input() isRequired: boolean = false;
    @Input() isIncludeInactive: boolean = true;
    @Input() isIncludeRetired: boolean = false;
    //@Input() isShowClearButton: boolean = false;
    @Input() defaultCustomer: string = "";

    @Output() customerSelected = new EventEmitter<any>();
    @Output() customerBlurred = new EventEmitter<any>();

    @ViewChild('autoTrigger', { static: false, read: MatAutocompleteTrigger }) autoTrigger!: MatAutocompleteTrigger;
    @ViewChild('customer', { static: false }) customer!: MatAutocomplete;

    //public customers: CustomerLookup[] = [];
    public customersStartsWith: Array<string> = [];
    public filteredResponse: Observable<APIResponse> = new Observable<APIResponse>();
    public filteredCustomers: CustomerLookup[] = [];
    public selectedCustomerID: number = 0;
    public displayValue: string = "";
    public ariaLabel: string = "";
    public isError: boolean = false;
    public errorDetail: string = "";
    public isKendo: boolean = false;

    constructor(private applicationControlService: ApplicationControlService, private crmService: CRMService) { }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName('UITypeaheadSource', false).subscribe(result => {
            if (result.length > 0) {
                this.isKendo = result[0].appSettingValue == "kendo";
            }
        });
        this.ariaLabel = this.placeholder;
        if (this.placeholder) {
            this.errorDetail = "Please " + this.placeholder.toLowerCase();
        }
        //this.getCustomers();
        if (this.defaultCustomer != "") {
            this.placeholder = this.defaultCustomer;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCustomer);
        }
        else {
        }
        this.filteredResponse = this.parentForm!.controls[this.ctrlName].valueChanges.pipe(
            startWith(''),
            debounceTime(300),
            switchMap(customer => customer ? this.filterCustomers(customer) : new Array())
        );
        this.filteredResponse.subscribe(result => {
            var lst: CustomerLookup[] = result.resultCollection;
            if (!this.isIncludeInactive) {
                lst = lst.filter(t => t.isActive == true);
            }
            if (!this.isIncludeRetired) {
                lst = lst.filter(t => t.isRetired == false);
            }
            lst = lst.sort((left, right): number => {
                if (left.customerCode < right.customerCode) return -1;
                if (left.customerCode > right.customerCode) return 1;
                return 0;
            });
            this.filteredCustomers = lst;
            //console.log("filteredCustomers", this.filteredCustomers);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        var ok = changes;

        if (this.defaultCustomer != "") {
            this.placeholder = this.defaultCustomer;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCustomer);
        }

        if (changes.customerID == null || changes.customerID.currentValue == null) return;

        this.selectedCustomerID = parseInt(changes.customerID.currentValue);
    }

    private filterCustomers(value: string) {
        //console.log("filterCustomers", value);
        if (typeof value !== 'string') return new Array();
        const filterValue = value.toLowerCase();
        if (filterValue.length < 3) return new Array();
        return this.crmService.getAllSearchCustomerLookupByCode(this.lookupType, value);
    }

    public getCustomerLookup(value: string) {
        //console.log("filterCustomers", value);
        if (value.length < 3) {
            this.filteredCustomers = [];
            return;
        }
        this.crmService.getAllSearchCustomerLookupByCode(this.lookupType, value).subscribe(result => {
            var lst: CustomerLookup[] = result.resultCollection;
            if (!this.isIncludeInactive) {
                lst = lst.filter(t => t.isActive == true);
            }
            if (!this.isIncludeRetired) {
                lst = lst.filter(t => t.isRetired == false);
            }
            lst = lst.sort((left, right): number => {
                if (left.customerCode < right.customerCode) return -1;
                if (left.customerCode > right.customerCode) return 1;
                return 0;
            });
            this.filteredCustomers = lst;
        });
    }

    //public clearOption() {
    //    this.parentForm!.controls[this.ctrlName].setValue('');
    //    this.optionChanged('');
    //}

    public chooseActiveCustomer(event: any) {
        //console.log("choseActiveCustomer", this.autoTrigger);
        //var displayValue = "";

        if (this.autoTrigger.activeOption) {
            this.parentForm!.controls[this.ctrlName].setValue(this.autoTrigger.activeOption.value);
            this.optionChanged(event);
            //console.log("chooseActiveCustomer:activeOption", displayValue);
            return;
        } else if (this.autoTrigger.autocomplete.options.first) {
            this.parentForm!.controls[this.ctrlName].setValue(this.autoTrigger.autocomplete.options.first.value);
            this.optionChanged(this.autoTrigger.autocomplete.options.first.value);
            //console.log("chooseActiveCustomer:autocomplete", displayValue);
            //console.log("choseActiveCustomer", this.autoTrigger.autocomplete.options.first.value);
        }

        if (this.isChooseFirstCustomer != true || this.customer.options.length < 1) return;

        //console.log("chooseActiveCustomer:first", displayValue);
        this.parentForm!.controls[this.ctrlName].setValue(this.customer.options.first.value);
    }

    //private getTextDisplay(val: CustomerLookup) {
    //    //var idx = val.indexOf("<br");
    //    //if (idx > 0) {
    //    //    val = val.substring(0, idx);
    //    //}
    //    var displayValue = val.customerCode + " - " + val.name;
    //    return displayValue;
    //}

    public optionChanged(evt: any) {
        //console.log("optionChanged", evt);
        if (this.isKendo) {
            var idx = this.filteredCustomers.findIndex(t => t.customerCode == evt);
            //console.log("optionChanged", idx);
            if (idx >= 0) {
                //console.log("optionChanged", this.filteredCustomers[idx]);
                this.customerSelected.emit(this.filteredCustomers[idx].customerID);
            }
            //else if (evt == null || evt == '') {
            //    this.customerSelected.emit(0);
            //}
        }
        else {
            if (evt.option) {
                this.customerSelected.emit(evt.option.value);
            }
            else if (evt.customerID) {
                this.customerSelected.emit(evt);
            }
            else {
                this.customerSelected.emit(0);
            }
        }
        //this.filteredCustomers = new Observable<CustomerLookup[]>();
        this.filteredCustomers = [];
    }

    public optionBlurred() {
        if (this.displayValue == "") {
            this.customerSelected.emit(0);
        }
        this.customerBlurred.emit();
    }

    public displayCustomer(customer?: CustomerLookup): string | undefined {
        var disp = "";
        if (customer) {
            disp = customer!.customerCode + " - " + customer!.name;
            //disp += "<br />";
            //disp += "<small>" + customer!.address1 + ", " + customer!.cityST + "</small>";
        }
        //console.log("displayCustomer", this.lookupType, disp, customer);
        return disp;
        //return customer ? (this.isCustomerCode ? customer.customerCode : customer.name) : undefined;
        //return customer ? customer.customerStateZip : undefined;
    }

    public isValid() {
        return this.parentForm!.controls[this.ctrlName].hasError('required');
    }
}